// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   TextField,
//   IconButton,
//   LinearProgress,
// } from "@mui/material";
// import { Edit, Delete } from "@mui/icons-material";
// import TableComponent from "../../Components/TableComponent/TableComponent";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import { LoadingSpinner } from "../../Components/spinner/spinner";
// import { API_BASE_URL } from "../../config";
// import api from "../../api/axiosInterceptor";
// import axios from "axios";

// export const AdminTenderComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("info");

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedTender, setSelectedTender] = useState(null);

//   const [formData, setFormData] = useState({
//     subject: "",
//     date_of_issue: "",
//     language: "",
//   });

//   const [selectedFile, setSelectedFile] = useState(null);
//   const [formErrors, setFormErrors] = useState({});

//   const [uploading, setUploading] = useState(false);
//   const [uploadProgress, setUploadProgress] = useState(0);

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteTender, setDeleteTender] = useState(null);

//   const columns = [
//     { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
//     { id: "subject", field: "subject", headerName: "Subject", width: 250 },
//     { id: "dateOfIssue", field: "dateOfIssue", headerName: "Date Of Issue", width: 150 },
//     { id: "language", field: "language", headerName: "Language", width: 150 },
//     {
//       id: "links",
//       field: "links",
//       headerName: "Links",
//       width: 120,
//       renderCell: (params) =>
//         params.value ? (
//           <a href={params.value} target="_blank" rel="noopener noreferrer">
//             Download
//           </a>
//         ) : (
//           "No File"
//         ),
//     },
//     {
//       id: "actions",
//       field: "actions",
//       headerName: "Actions",
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchTenders();
//   }, []);

//   const fetchTenders = () => {
//     setLoading(true);
//     axios
//       .get(`${API_BASE_URL}/home-notification/tender/`)
//       .then((response) => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id || index,
//           slNo: index + 1,
//           subject: item.subject,
//           dateOfIssue: item.date_of_issue,
//           language: item.language,
//           links: item.link || "",
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch(() => {
//         setSnackbarMessage("Failed to load tender data.");
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => setSnackbarOpen(false);

//   const handleAddTender = () => {
//     setIsEditMode(false);
//     setFormData({ subject: "", date_of_issue: "", language: "" });
//     setSelectedFile(null);
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (tender) => {
//     setIsEditMode(true);
//     setSelectedTender(tender);
//     setFormData({
//       subject: tender.subject,
//       date_of_issue: tender.dateOfIssue,
//       language: tender.language,
//     });
//     setSelectedFile(null);
//     setFormErrors({});
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (tender) => {
//     setDeleteTender(tender);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api
//       .delete(`${API_BASE_URL}/home-notification/tender/${deleteTender.id}/`)
//       .then(() => {
//         setSnackbarMessage("Tender deleted successfully.");
//         setSnackbarSeverity("success");
//         setSnackbarOpen(true);
//         fetchTenders();
//       })
//       .catch(() => {
//         setSnackbarMessage("Failed to delete tender.");
//         setSnackbarSeverity("error");
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteTender(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.subject?.trim()) errors.subject = "Subject is required";
//     if (!formData.date_of_issue) errors.date_of_issue = "Date of issue is required";
//     if (!formData.language?.trim()) errors.language = "Language is required";
//     if (!selectedFile && !isEditMode) errors.file = "File is required";
//     if (selectedFile && selectedFile.size > 2 * 1024 * 1024) errors.file = "File size must be less than 2MB";
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files[0];
//     if (file && file.size > 2 * 1024 * 1024) {
//       setFormErrors({ ...formErrors, file: "File size must be less than 2MB" });
//       setSelectedFile(null);
//     } else {
//       setFormErrors({ ...formErrors, file: null });
//       setSelectedFile(file);
//     }
//   };

//   const handleFormSubmit = async () => {
//     if (!validateForm()) return;

//     const form = new FormData();
//     form.append("subject", formData.subject);
//     form.append("date_of_issue", formData.date_of_issue);
//     form.append("language", formData.language);
//     if (selectedFile) form.append("link", selectedFile);

//     try {
//       setUploading(true);
//       setUploadProgress(0);

//       if (isEditMode) {
//         await api.patch(`${API_BASE_URL}/home-notification/tender/${selectedTender.id}/`, form, {
//           headers: { "Content-Type": "multipart/form-data" },
//           onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//         });
//         setSnackbarMessage("Tender updated successfully.");
//       } else {
//         await api.post(`${API_BASE_URL}/home-notification/tender/`, form, {
//           headers: { "Content-Type": "multipart/form-data" },
//           onUploadProgress: (e) => setUploadProgress(Math.round((e.loaded * 100) / e.total)),
//         });
//         setSnackbarMessage("Tender added successfully.");
//       }

//       setSnackbarSeverity("success");
//       setSnackbarOpen(true);
//       fetchTenders();
//       setOpenFormDialog(false);
//     } catch {
//       setSnackbarMessage("Failed to submit tender.");
//       setSnackbarSeverity("error");
//       setSnackbarOpen(true);
//     } finally {
//       setUploading(false);
//       setUploadProgress(0);
//     }
//   };

//   if (loading) return <LoadingSpinner size={30} />;

//   return (
//     <Box sx={{ width: "100%", mt: 8, mb: 1, borderRadius: 2, boxShadow: "0 4px 12px rgba(0,0,0,0.1)", backgroundColor: "#fff" }}>
//       <Box display="flex" justifyContent="space-between" alignItems="center" bgcolor="rgba(195,234,203,0.1)" p={2}>
//         <Typography variant="h4" component="h1" fontWeight="bold">Tenders</Typography>
//         <Button variant="contained" color="primary" onClick={handleAddTender} disabled={uploading}>Add Tender</Button>
//       </Box>

//       <TableComponent columns={columns} rows={rows} manageColumnStatus enableSort sx={{ "& .MuiDataGrid-columnHeaders": { backgroundColor: "#1976d2", color: "#fff", fontWeight: "bold" }}} />

//       <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
//         <DialogTitle>{isEditMode ? "Edit Tender" : "Add Tender"}</DialogTitle>
//         <DialogContent>
//           <TextField margin="dense" label="Subject" fullWidth value={formData.subject} error={!!formErrors.subject} helperText={formErrors.subject} onChange={(e) => setFormData({ ...formData, subject: e.target.value })} disabled={uploading} />
//           <TextField margin="dense" type="date" label="Date Of Issue" fullWidth value={formData.date_of_issue} error={!!formErrors.date_of_issue} helperText={formErrors.date_of_issue} onChange={(e) => setFormData({ ...formData, date_of_issue: e.target.value })} InputLabelProps={{ shrink: true }} disabled={uploading} />
//           <TextField margin="dense" label="Language" fullWidth value={formData.language} error={!!formErrors.language} helperText={formErrors.language} onChange={(e) => setFormData({ ...formData, language: e.target.value })} disabled={uploading} />
//           <Box mt={2}>
//             <input type="file" accept="*" style={{ display: "block", marginTop: 8 }} onChange={handleFileChange} disabled={uploading} />
//             {formErrors.file && <Typography variant="body2" color="error" sx={{ mt: 1 }}>{formErrors.file}</Typography>}
//             {isEditMode && !selectedFile && selectedTender?.links && (
//               <Typography variant="body2" sx={{ mt: 1 }}>
//                 Current File:{" "}
//                 <a href={`${API_BASE_URL}${selectedTender.links}`} target="_blank" rel="noopener noreferrer">View Details</a>
//               </Typography>
//             )}
//           </Box>
//           {uploading && (
//             <Box sx={{ mt: 2 }}>
//               <LinearProgress variant="determinate" value={uploadProgress} />
//               <Typography variant="body2" sx={{ textAlign: "center", mt: 1 }}>
//                 Uploading... {uploadProgress}%
//               </Typography>
//             </Box>
//           )}
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>Cancel</Button>
//           <Button variant="contained" color="primary" onClick={handleFormSubmit} disabled={uploading}>
//             {isEditMode ? "Update" : "Add"}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>Are you sure you want to delete this tender?</DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>Cancel</Button>
//           <Button variant="contained" color="error" onClick={handleDelete} disabled={uploading}>Delete</Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent open={snackbarOpen} message={snackbarMessage} severity={snackbarSeverity} onClose={handleSnackbarClose} />
//     </Box>
//   );
// };


import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  LinearProgress,
  CircularProgress,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import TableComponent from "../../Components/TableComponent/TableComponent";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import { LoadingSpinner } from "../../Components/spinner/spinner";
import { API_BASE_URL } from "../../config";
import api from "../../api/axiosInterceptor";
import axios from "axios";

export const AdminTenderComponent = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("info");

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedTender, setSelectedTender] = useState(null);

  const [formData, setFormData] = useState({
    subject: "",
    date_of_issue: "",
    language: "",
  });

  const [selectedFile, setSelectedFile] = useState(null);
  const [formErrors, setFormErrors] = useState({});

  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteTender, setDeleteTender] = useState(null);

  const columns = [
    { id: "slNo", field: "slNo", headerName: "Sl No.", width: 70 },
    { id: "subject", field: "subject", headerName: "Subject", width: 250 },
    { id: "dateOfIssue", field: "dateOfIssue", headerName: "Date Of Issue", width: 150 },
    { id: "language", field: "language", headerName: "Language", width: 150 },
    {
      id: "links",
      field: "links",
      headerName: "Links",
      width: 120,
      renderCell: (params) =>
        params.value ? (
          <a href={params.value} target="_blank" rel="noopener noreferrer">
            Download
          </a>
        ) : (
          "No File"
        ),
    },
    {
      id: "actions",
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)} disabled={uploading}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)} disabled={uploading}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchTenders();
  }, []);

  const fetchTenders = () => {
    setLoading(true);
    axios
      .get(`${API_BASE_URL}/home-notification/tender/`)
      .then((response) => {
        const apiData = response.data.map((item, index) => ({
          id: item.id || index,
          slNo: index + 1,
          subject: item.subject,
          dateOfIssue: item.date_of_issue,
          language: item.language,
          links: item.link || "",
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch(() => {
        setSnackbarMessage("Failed to load tender data.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleAddTender = () => {
    setIsEditMode(false);
    setFormData({ subject: "", date_of_issue: "", language: "" });
    setSelectedFile(null);
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleEdit = (tender) => {
    setIsEditMode(true);
    setSelectedTender(tender);
    setFormData({
      subject: tender.subject,
      date_of_issue: tender.dateOfIssue,
      language: tender.language,
    });
    setSelectedFile(null);
    setFormErrors({});
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (tender) => {
    setDeleteTender(tender);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api
      .delete(`/home-notification/tender/${deleteTender.id}/`)
      .then(() => {
        setSnackbarMessage("Tender deleted successfully.");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        fetchTenders();
      })
      .catch(() => {
        setSnackbarMessage("Failed to delete tender.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteTender(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.subject?.trim()) errors.subject = "Subject is required";
    if (!formData.date_of_issue) errors.date_of_issue = "Date of issue is required";
    if (!formData.language?.trim()) errors.language = "Language is required";
    if (!selectedFile && !isEditMode) errors.file = "File is required";
    if (selectedFile && selectedFile.size > 2 * 1024 * 1024)
      errors.file = "File size must be less than 2MB";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > 2 * 1024 * 1024) {
      setFormErrors({ ...formErrors, file: "File size must be less than 2MB" });
      setSelectedFile(null);
    } else {
      setFormErrors({ ...formErrors, file: null });
      setSelectedFile(file);
    }
  };

  const handleFormSubmit = async () => {
    if (!validateForm()) return;

    const form = new FormData();
    form.append("subject", formData.subject);
    form.append("date_of_issue", formData.date_of_issue);
    form.append("language", formData.language);
    if (selectedFile) form.append("link", selectedFile);

    try {
      setUploading(true);
      setUploadProgress(0);

      if (isEditMode) {
        await api.patch(
          `/home-notification/tender/${selectedTender.id}/`,
          form,
          {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (e) =>
              setUploadProgress(Math.round((e.loaded * 100) / e.total)),
          }
        );
        setSnackbarMessage("Tender updated successfully.");
      } else {
        await api.post(`/home-notification/tender/`, form, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (e) =>
            setUploadProgress(Math.round((e.loaded * 100) / e.total)),
        });
        setSnackbarMessage("Tender added successfully.");
      }

      setSnackbarSeverity("success");
      setSnackbarOpen(true);
      fetchTenders();
      setOpenFormDialog(false);
    } catch {
      setSnackbarMessage("Failed to submit tender.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setUploading(false);
      setUploadProgress(0);
    }
  };

  if (loading) return <LoadingSpinner size={30} />;

  return (
    <Box
      sx={{
        width: "100%",
        mt: 8,
        mb: 1,
        borderRadius: 2,
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        bgcolor="rgba(195,234,203,0.1)"
        p={2}
      >
        <Typography variant="h4" component="h1" fontWeight="bold">
          Tenders
        </Typography>
        <Button variant="contained" color="primary" onClick={handleAddTender} disabled={uploading}>
          Add Tender
        </Button>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort
        sx={{
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#1976d2",
            color: "#fff",
            fontWeight: "bold",
          },
        }}
      />

      <Dialog open={openFormDialog} onClose={() => !uploading && setOpenFormDialog(false)}>
        <DialogTitle>{isEditMode ? "Edit Tender" : "Add Tender"}</DialogTitle>
        <DialogContent>
          <TextField
            margin="dense"
            label="Subject"
            fullWidth
            value={formData.subject}
            error={!!formErrors.subject}
            helperText={formErrors.subject}
            onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            type="date"
            label="Date Of Issue"
            fullWidth
            value={formData.date_of_issue}
            error={!!formErrors.date_of_issue}
            helperText={formErrors.date_of_issue}
            onChange={(e) => setFormData({ ...formData, date_of_issue: e.target.value })}
            InputLabelProps={{ shrink: true }}
            disabled={uploading}
          />
          <TextField
            margin="dense"
            label="Language"
            fullWidth
            value={formData.language}
            error={!!formErrors.language}
            helperText={formErrors.language}
            onChange={(e) => setFormData({ ...formData, language: e.target.value })}
            disabled={uploading}
          />
          <Box mt={2}>
            <input
              type="file"
              accept="*"
              style={{ display: "block", marginTop: 8 }}
              onChange={handleFileChange}
              disabled={uploading}
            />
            {formErrors.file && (
              <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                {formErrors.file}
              </Typography>
            )}
            {isEditMode && !selectedFile && selectedTender?.links && (
              <Typography variant="body2" sx={{ mt: 1 }}>
                Current File:{" "}
                <a href={`${API_BASE_URL}${selectedTender.links}`} target="_blank" rel="noopener noreferrer">
                  View Details
                </a>
              </Typography>
            )}
          </Box>
          {uploading && (
            <Box sx={{ mt: 2 }}>
              <LinearProgress variant="determinate" value={uploadProgress} />
              <Typography variant="body2" sx={{ textAlign: "center", mt: 1 }}>
                Uploading... {uploadProgress}%
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => !uploading && setOpenFormDialog(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" onClick={handleFormSubmit} disabled={uploading}>
            {uploading ? <CircularProgress size={24} color="inherit" /> : isEditMode ? "Update" : "Add"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>Are you sure you want to delete this tender?</DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={uploading}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete} disabled={uploading}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};
